import { Module } from 'utils/types/RentModels';

export const getNormalizedRentModuleName = (moduleName: Module) => {
    return moduleName.split('_')[1].toLowerCase();
};
